// (c) Copyright 2022 Sorriso Technologies, Inc(r), All Rights Reserved,
// Patents Pending.
//
// This product is distributed under license from Sorriso Technologies, Inc.
// Use without a proper license is strictly prohibited.  To license this
// software, you may contact Sorriso Technologies at:

// Sorriso Technologies, Inc.
// 400 West Cummings Park
// Suite 1725-184
// Woburn, MA 01801, USA
// +1.978.635.3900

// "Sorriso Technologies", "You and Your Customers Together, Online", "Persona
// Solution Suite by Sorriso", the Sorriso Logo and Persona Solution Suite Logo
// are all Registered Trademarks of Sorriso Technologies, Inc.  "Information Is
// The New Online Currency", "e-TransPromo", "Persona Enterprise Edition",
// "Persona SaaS", "Persona Services", "SPN - Synergy Partner Network",
// "Sorriso Synergy", "Our DNA Is In Online", "Persona E-Bill & E-Pay",
// "Persona E-Service", "Persona Customer Intelligence", "Persona Active
// Marketing", and "Persona Powered By Sorriso" are trademarks of Sorriso
// Technologies, Inc.
import $ from 'jquery';

import { ElementState  } from './element_state';
import { ValidatorBase } from './validator_base';

function strip_time(
            date:Date 
        ) : Date {
    date.setHours(0,0,0,0);
    return date;
}

export class ValidatorDate extends ValidatorBase {
    //*************************************************************************
    private min : Date|undefined;
    private max : Date|undefined;

    //*************************************************************************
    constructor(
                state : ElementState,
                field : JQuery<any>
            ) {
        super(state, field);

        if (field.attr('st-date-min') !== undefined) {
            var days = Number(field.attr('st-date-min'));
            this.min = strip_time(new Date(new Date().getTime() - days * 24 * 60 * 60 * 1000));
        }

        if (field.attr('st-date-max') !== undefined) {
            var days = Number(field.attr('st-date-max'));
            this.max = strip_time(new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000));
        }

    }

    //*************************************************************************
    protected validate() : boolean|undefined {
        const value = this.as_string();

        if (value !== '') {
            const format = this.field.attr('st-date-format');
            if (format !== undefined) {
                try {
                    const date = $.datepicker.parseDate(format, value);

                    if (this.min !== undefined && date < this.min) {
                        return false;
                    }

                    if (this.max !== undefined && date > this.max) {
                        return false;
                    }

                    return true;
                } catch(e) {
                    return false;
                }
            } else {
                return true;
            }
        }

        return true;
    }
}